import { setAppError, setPathingAppState } from "../../actions/App/dispatchers";
import { fetch_author } from "../../actions/Author/dispatchers";
import { reset_right_rail } from "../../reducers/RightRail/reducer";
import { fetch_supplementary_data } from "../../actions/RightRail/dispatchers";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";
import {
    getIsMetaPreview,
    metaPreviewReplacer,
} from "../../utils/page/library";

export const fetchAuthorProfilePageData = (path, params) => (dispatch) => {
    const { contentId, section } = params;
    const isPreview = getIsMetaPreview(path);
    const newPath = isPreview ? metaPreviewReplacer(path) : path;

    dispatch(reset_app_state(newPath));
    dispatch(reset_right_rail());

    return dispatch(fetch_author({ contentId, page: 1 }))
        .then(() => {
            dispatch(fetch_supplementary_data(section));
            dispatch(setPathingAppState(newPath, false, contentId));
        })
        .catch((error) => {
            dispatch(setAppError(newPath, error.code));
        });
};
